var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lightbox',{attrs:{"active":_vm.active,"images":_vm.images,"initial-index":0,"prev-icon":"fa fa-chevron-left","next-icon":"fa fa-chevron-right","close-icon":"fa fa-close"},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }